import React from "react";

import { Card, Col, Icon, Row } from "components";

export type AccessCardProps = {
  variant?: "actionable" | "warning" | "alert";
  className?: string;
  contentTop?: React.ReactNode;
  contentBottom?: React.ReactNode;
  headline: string;
  description: string;
  mixpanelText?: string;
  dataTestId?: string;
  onClick?: (e: React.MouseEvent) => void;
};

export const AccessCard = ({
  className = "",
  variant = "actionable",
  contentTop,
  contentBottom,
  headline,
  description,
  onClick,
  mixpanelText,
  dataTestId,
}: AccessCardProps) => (
  <Card className={`access-card ${variant} ${className} ${onClick ? "pointer" : ""}`} onClick={onClick} mixpanelText={mixpanelText} dataTestId={dataTestId}>
    {contentTop}

    <div className="content">
      <Row align="middle" className="padding-bottom-0">
        <Col sm={23}>
          <h2>{headline}</h2>
        </Col>
        <Col sm={1} className="padding-right-0 right">
          <Icon iconName="tabler/chevron-right" className="icon inline" />
        </Col>
      </Row>

      <Row className="margin-top-50 padding-bottom-0">
        <Col>
          <p className="paragraph-s margin-0">{description}</p>
        </Col>
      </Row>

      {contentBottom}
    </div>
  </Card>
);
